import { render, staticRenderFns } from "./custom-head.vue?vue&type=template&id=5d15c8bb&scoped=true&"
import script from "./custom-head.vue?vue&type=script&lang=js&"
export * from "./custom-head.vue?vue&type=script&lang=js&"
import style0 from "./custom-head.vue?vue&type=style&index=0&id=5d15c8bb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d15c8bb",
  null
  
)

export default component.exports